import options from './options';
import tabs from './tabs';
import mobile from './mobile';


export default function() {
	options.init();
	tabs.init();
	mobile();
}
